const ingredients = [
  {
    name: '人參萃取',
    latinName: 'Panax Ginseng',
    description: '補氣養血，提升耐力與抗疲勞能力，幫助改善血液循環，是傳統醫學中的百草之王。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20ginseng%20root%20on%20warm%20cream%20background%2C%20minimalist%20botanical%20photography%2C%20soft%20lighting%2C%20natural%20organic%20feel%2C%20luxurious%20wellness%20aesthetic&width=400&height=400&seq=xfb-ing-ginseng&orientation=squarish',
  },
  {
    name: '枸杞精華',
    latinName: 'Lycium Barbarum',
    description: '富含多種維生素與抗氧化物質，滋補肝腎，有助提升整體活力與免疫力。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20goji%20berries%20on%20warm%20cream%20background%2C%20minimalist%20botanical%20photography%2C%20soft%20lighting%2C%20natural%20organic%20feel%2C%20luxurious%20wellness%20aesthetic&width=400&height=400&seq=xfb-ing-goji&orientation=squarish',
  },
  {
    name: '淫羊藿萃取',
    latinName: 'Epimedium',
    description: '傳統壯陽益精之品，現代研究證實其有效成分有助於促進血液流動，支持健康生理功能。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20dried%20epimedium%20herb%20leaves%20on%20warm%20cream%20background%2C%20minimalist%20botanical%20photography%2C%20soft%20lighting%2C%20natural%20organic%20feel%2C%20luxurious%20wellness%20aesthetic&width=400&height=400&seq=xfb-ing-epimedium&orientation=squarish',
  },
  {
    name: '瑪卡根粉',
    latinName: 'Maca Root',
    description: '源自秘魯安第斯山脈的天然活力之源，幫助調節內分泌平衡，提升能量水平。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20maca%20root%20powder%20on%20warm%20cream%20background%2C%20minimalist%20botanical%20photography%2C%20soft%20lighting%2C%20natural%20organic%20feel%2C%20luxurious%20wellness%20aesthetic&width=400&height=400&seq=xfb-ing-maca&orientation=squarish',
  },
];

function IngredientsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            核心天然成分
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            精選全球優質天然草本，經科學配比與先進萃取工藝，打造高效安全的活力配方
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {ingredients.map((ingredient, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg overflow-hidden group cursor-default">
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={ingredient.image}
                  alt={`${ingredient.name} - ${ingredient.latinName}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">{ingredient.name}</h3>
                <p className="text-xs text-foreground-500 italic mb-3">{ingredient.latinName}</p>
                <p className="text-sm text-foreground-600 leading-relaxed">{ingredient.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default IngredientsSection;